import { render, staticRenderFns } from "./drApplyBase.vue?vue&type=template&id=338e8ae0&scoped=true&"
import script from "./drApplyBase.vue?vue&type=script&lang=js&"
export * from "./drApplyBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338e8ae0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/suifeng/Desktop/projects/2022/sdGG/sdGGAdmin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('338e8ae0')) {
      api.createRecord('338e8ae0', component.options)
    } else {
      api.reload('338e8ae0', component.options)
    }
    module.hot.accept("./drApplyBase.vue?vue&type=template&id=338e8ae0&scoped=true&", function () {
      api.rerender('338e8ae0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/applyManage/drApplyBase.vue"
export default component.exports